module.exports = __webpack_public_path__ + "img/arena_round.8024656c.png";